import { ApplicationState } from '..';

export const caseSearch = (state: ApplicationState) => state.caseState.caseSearch;
export const selectedCase = (state: ApplicationState) => state.caseState.selectedCase;
